export class UtilityManagementCollections {
    static ModuleName = 'utility-management';

    static Attachments = `${UtilityManagementCollections.ModuleName}/attachments`;

    static attachment(attachmentId: string) {
        return `${UtilityManagementCollections.Attachments}/${attachmentId}`;
    }

    static attachmentDownloadUrl(attachmentId: string) {
        return `${UtilityManagementCollections.Attachments}/${attachmentId}/as-download-url`;
    }

    static Notifications = `${UtilityManagementCollections.ModuleName}/notifications`;
    static StockUpdates = `${UtilityManagementCollections.Notifications}/stock-updates`;

    static notificationLookups() {
        return `${UtilityManagementCollections.Notifications}/lookups`;
    }

    static MyNotifications = `${UtilityManagementCollections.Notifications}/me`;

    static myNotificationsUnseenCount() {
        return `${UtilityManagementCollections.MyNotifications}/unseen-count`;
    }

    static myNotificationsSeen() {
        return `${UtilityManagementCollections.MyNotifications}/seen`;
    }

    static deviceTopics(deviceIdentifier: string) {
        return `${UtilityManagementCollections.Notifications}/devices/${encodeURIComponent(deviceIdentifier)}/topics`;
    }
}
